module.exports = __webpack_public_path__ + "img/fail.8d391d7b.png";